module.exports = __webpack_public_path__ + "img/result-rate.2bfc3bf4.png";